import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  IconButton,
  Tooltip
} from "@mui/material";
import React, { useState } from "react";

import { FeatureFlag } from "../../../common/posthog";
import AhaLenses from "./AhaLenses";

interface AhaLensesButtonProps {
  onSelectQuestion: (question: string) => void;
}

const AhaLensesButton: React.FC<AhaLensesButtonProps> = ({ onSelectQuestion }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = (): void => {
    setDialogOpen(true);
  };

  const handleCloseDialog = (): void => {
    setDialogOpen(false);
  };

  return (
    <FeatureFlag flag="aha-lens-user" fallback={null}>
      <Tooltip title="Aha Lenses">
        <IconButton
          onClick={handleOpenDialog}
          color="primary"
          size="small"
          edge="start"
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>

      <AhaLenses
        open={dialogOpen}
        onClose={handleCloseDialog}
        onSelectQuestion={onSelectQuestion}
      />
    </FeatureFlag>
  );
};

export default AhaLensesButton;
